<script>
    export let classes = 'bg-light';

    import { onMount } from 'svelte';

    export let hasHeader = true;
    export let hasFooter = true;
    export let hasTitle = true;

    export let isDismissible = false;

    onMount(() => {
        hasHeader = !!$$slots.header;
        hasTitle = !!$$slots.title
        hasFooter = !!$$slots.footer;
    });

</script>

<div class={`card ${classes}`} role={isDismissible ? 'role=alert' : ''}>

    {#if isDismissible}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    {/if}

    {#if hasHeader}
        <div class="card-header">
            <h3 class="card-title m-0 p-0"><slot name="header">Header</slot></h3>
        </div>
    {/if}
        <div class="card-body">

            {#if hasHeader}
                <h4 class="card-title m-0 p-0 md-4"><slot name="title">Header</slot></h4>
            {/if}
            <slot name="content">Default card content.</slot>
        </div>
    {#if hasFooter}

        <slot name="footer">Default card footer.</slot>

    {/if}
</div>
